/* eslint-disable jira/i18n/id-named-by-package */

import { defineMessages } from '@atlassian/jira-intl';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';

type MessageKeys =
	| 'fetchFailedFlagTitle'
	| 'fetchFailedFlagDescription'
	| 'uploadFailedFlagTitle'
	| 'uploadFailedFlagDescription';

export const messages: Record<MessageKeys, MessageDescriptor> = defineMessages({
	fetchFailedFlagTitle: {
		id: 'project-settings-apps.common.avatar-service.fetch-failed-flag-title',
		defaultMessage: "We couldn't find our default icons",
		description: 'Flag title if default icons could not be loaded',
	},
	fetchFailedFlagDescription: {
		id: 'project-settings-apps.common.avatar-service.fetch-failed-flag-description',
		defaultMessage:
			'Upload your own image, or refresh the page to retry loading our default images.',
		description: 'Flag description if default icons could not be loaded',
	},
	uploadFailedFlagTitle: {
		id: 'project-settings-apps.common.avatar-service.upload-failed-flag-title',
		defaultMessage: "We couldn't upload your image",
		description: 'Flag title if an icon image could not be uploaded',
	},
	uploadFailedFlagDescription: {
		id: 'project-settings-apps.common.avatar-service.upload-failed-flag-description',
		defaultMessage: 'Something went wrong. Try again.',
		description: 'Flag description if an icon image could not be uploaded',
	},
});
